import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DrugEquipment, DrugEquipmentList } from '../models/drug-equipment.model';
import { AppResponse } from '../../../shared/models/app.model';
import { getFullUrl } from '../../../shared/utils/utils';
import { endpoint } from '../../../../enviroment/endpoint';
import { SearchDrugEquipmentsRequest } from '../models/label.model';

@Injectable({
  providedIn: 'root'
})
export class DrugEquipmentService {
  httpClient = inject(HttpClient);

  getDrugEquipmentList(param: any): Observable<AppResponse<DrugEquipmentList>> {
    const url = getFullUrl(endpoint.drugEquipment.url);
    return this.httpClient.get<AppResponse<DrugEquipmentList>>(url, {
      params: param
    });
  }

  searchDrugEquipments(request: SearchDrugEquipmentsRequest): Observable<AppResponse<DrugEquipment[]>> {
    const url = getFullUrl(endpoint.drugEquipment.url, endpoint.drugEquipment.search);
    return this.httpClient.post<AppResponse<DrugEquipment[]>>(url, request);
  }

  searchProgram(search: SearchDrugEquipmentsRequest): Observable<AppResponse<DrugEquipment[]>> {
    const url = getFullUrl(endpoint.drugEquipment.url, endpoint.drugEquipment.searchProgram);
    return this.httpClient.post<AppResponse<DrugEquipment[]>>(url, search);
  }

  saveDrugEquipment(payload: DrugEquipment): Observable<any> {
    const url = getFullUrl(endpoint.drugEquipment.url);
    return this.httpClient.post<any>(url, payload);
  }

  deleteDrugEquipment(id: string): Observable<any> {
    const url = getFullUrl(endpoint.drugEquipment.url, endpoint.drugEquipment.delete, { id });
    return this.httpClient.delete<any>(url);
  }
}
